import styled, { css } from "styled-components";
import Input from "../../common/components/Input";
import { ChangeEvent, useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { media } from "../../media";
import Header from "../../common/header";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../common/Layout";

export default function Login() {
  const nav = useNavigate();
  const [isButtonOn, setIsButtonOn] = useState(false);
  const [input, setInput] = useState({
    email: "",
    password: "",
  });
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const { success, login, error } = useAuth();
  // const { getCloudUser } = useUser();

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isButtonOn) return;
    await login(input.email, input.password);
  };

  useEffect(() => {
    if (success) {
      nav("/");
    }
  }, [success]);

  useEffect(() => {
    if (input.email && input.password) {
      setIsButtonOn(true);
    } else {
      setIsButtonOn(false);
    }
  }, [input]);

  const onClickBtn = () => {
    nav(-3);
  };

  return (
    <Layout>
      <LoginWrap isButtonOn={isButtonOn}>
        <Header />
        <div className="Banner">
          <div className="BackBtn" onClick={onClickBtn}>
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_526_247" fill="white">
                <path d="M16.9707 8.48535L8.48542 16.9706L0.000140667 8.48535L8.48542 7.03335e-05L16.9707 8.48535Z" />
              </mask>
              <path
                d="M0.000140667 8.48535L-0.706966 7.77824L-1.41407 8.48535L-0.706966 9.19246L0.000140667 8.48535ZM9.19253 16.2635L0.707247 7.77824L-0.706966 9.19246L7.77832 17.6777L9.19253 16.2635ZM0.707247 9.19246L9.19253 0.707177L7.77832 -0.707036L-0.706966 7.77824L0.707247 9.19246Z"
                fill="#314AF3"
                mask="url(#path-1-inside-1_526_247)"
              />
            </svg>
          </div>
          <h1>Signin</h1>
        </div>
        <div className="MainWrap">
          <div className="LeftLine"></div>
          <div className="FormWrap">
            <form onSubmit={onSubmit}>
              <Input
                name="email"
                value={input.email}
                onChange={onChange}
                placeholder="Email"
              />
              <Input
                name="password"
                value={input.password}
                onChange={onChange}
                placeholder="Password"
                type="password"
                autoComplete="password"
              />
              <p className="Error">{error}</p>
              <button>Login</button>
            </form>
          </div>
        </div>
        <div className="OAuth">
          {/* <img src={googleBtnNormal} alt="" onClick={loginWithGoogle}></img> */}
        </div>
        <div className="Menu">
          <p>
            <Link to="/admin/signup">Create Account</Link>
          </p>
        </div>
      </LoginWrap>
    </Layout>
  );
}

const LoginWrap = styled.div<{ isButtonOn: boolean }>`
  width: 100vw;
  height: 100%;
  overflow-y: auto;
  ${media.desktop`
    width: 393px;
  `}
  .Banner {
    display: flex;
    align-items: center;
    height: 200px;
    padding: 120px 0px 0px 0px;
    .BackBtn {
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    /* border-bottom: 1px solid #314af3; */
    h1 {
      font-family: nexa-bold;
      font-size: 24px;
    }
  }
  .MainWrap {
    position: relative;
    display: flex;
    /* justify-content: center; */
    /* align-items: start; */
    .LeftLine {
      width: 12px;
      height: 180px;
      margin: 20px 0px;
      background-color: #314af3;
    }
    .FormWrap {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      padding: 30px 42px 0px 30px;

      form {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: end;

        .Input {
          margin-bottom: 32px;
        }
        .Error {
          font-family: gmarket-sans-medium;
          font-size: 12px;
          color: #f94646;
          margin-bottom: 12px;
        }
        button {
          height: 50px;
          width: 100%;
          transition: all 0.16s ease-out;
          background-color: white;
          color: #314af3;
          border: 1px solid #314af3;
          font-family: nexa-bold;
          font-size: 18px;
          margin-top: 12px;
          cursor: default;
          ${({ isButtonOn }) =>
            isButtonOn &&
            css`
              background-color: #314af3;
              color: white;
              border: none;
              cursor: pointer;
            `}
        }
      }
    }
  }
  .OAuth {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 46px;
    margin-bottom: 20px;
    img {
      width: 191px;
      height: 46px;
      image-rendering: -webkit-optimize-contrast;
      transform: translateZ(0);
      backface-visibility: hidden;
      cursor: pointer;
    }
  }
  .Menu {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 120px;
    gap: 24px;
    p {
      font-size: 16px;
      cursor: pointer;
    }
  }
`;
